module.exports = __webpack_public_path__ + "img/sun-with-2cloud-rain.8100381e.png";